import { useState, useEffect, useRef } from "react";

function Header({
  page,
  notifs = [],
  onNotifRead,
  setPage,
  goBack,
  canGoBack,
  theme: themeProp,
  setTheme: setThemeProp,
  onLogout,
}) {
  const notifRef = useRef(null);

  const [localTheme, setLocalTheme] = useState(() => {
    try {
      const t = localStorage.getItem("theme");
      if (t) return t;
      return window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: light)").matches
        ? "light"
        : "dark";
    } catch (e) {
      return "dark";
    }
  });

  const theme = themeProp ?? localTheme;
  const setTheme = setThemeProp ?? setLocalTheme;

  useEffect(() => {
    try {
      const root = document.documentElement;
      if (theme === "light") root.classList.add("light-theme");
      else root.classList.remove("light-theme");
      localStorage.setItem("theme", theme);
    } catch (e) {}
  }, [theme]);

  useEffect(() => {
    const h = (e) => {
      if (notifRef.current && !notifRef.current.contains(e.target)) return;
    };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const titles = {
    dashboard: ["Dashboard", "Operational Overview"],
    customers: ["Customers", "Customer Management"],
    orders: ["Orders", "Order Management"],
    order: ["Order Detail", "Order Details"],
    "create-order": ["Create Order", "New Order"],
    collection: ["Collection", "Accounts Receivable"],
    reporting: ["Reporting", "Analytics & Reports"],
    inventory: ["Inventory", "Stock Management"],
    Inventory: ["Inventory", "Stock Management"],
    "Inventory 1": ["Inventory", "Stock Management"],
    deliveries: ["Transit", "Transit Schedule"],
    accounts: ["Accounts", "Credit & Account Management"],
    "account-detail": ["Account", "Account Detail"],
    "account-settings": ["Settings", "Account Settings"],
    Branch: ["Branches", "Branch Management"],
    warehouses: ["Warehouses", "Manage storage locations"],
    Maintenance: ["Maintenance", "System maintenance & settings"],
  };

  const [title, crumb] = titles[page] || ["BETA", ""];
  return (
    <div className="hdr">
      {/* ── Left: back button + title ── */}
      <div className="hdr-left">
        <div className="hdr-info">
          <div className="hdr-title">{title}</div>
          <div className="hdr-crumb">
            {crumb} |{" "}
            {new Date().toLocaleDateString("en-ZA", {
              weekday: "short",
              year: "numeric",
              month: "short",
              day: "numeric",
            })}
          </div>
        </div>
      </div>

      {/* ── Right: theme toggle only ── */}
      <div className="hdr-actions">
        <div
          className="hdr-btn"
          title={
            theme === "light" ? "Switch to dark mode" : "Switch to light mode"
          }
          onClick={() => setTheme((t) => (t === "light" ? "dark" : "light"))}
        >
          {theme === "light" ? (
            <i className="bi bi-moon" />
          ) : (
            <i className="bi bi-sun" />
          )}
        </div>
      </div>
    </div>
  );
}

export default Header;
